import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  withCredentials: true,
});

// Always attach Authorization fallback if we cached the token locally
api.interceptors.request.use((config) => {
  const tok = localStorage.getItem('sws_token');
  if (tok) {
    config.headers.Authorization = `Bearer ${tok}`;
  }
  return config;
});
